import { ReactElement } from 'react';
import { ActivityLogContainer } from '../../../modules/projectDetails/sub/activityLog/containers/ActivityLog.container';

export const ProjectDetailsActivityLogView = (): ReactElement => <ActivityLogContainer />;
